import React from 'react';
import classnames from 'classnames';
import style from './index.scss';

import SemiCircularBar from '../../../components/SemiCircularBar';

const TopInfoBar = ({ alertDetail, topInfoBarData }) => {
  //build up topbar elements
  let topInfoBar = [];
  for (let i = 0; i < topInfoBarData.length; i++) {
    const topInfoItem = topInfoBarData[i];
    let topInfoDisplay = alertDetail;

    // Check if the key is accessing child objects
    if (topInfoItem['key'].includes('.')) {
      const keyIndexes = topInfoItem['key'].split('.');
      keyIndexes.map((key) => {
        topInfoDisplay = topInfoDisplay?.[key] ? topInfoDisplay[key] : null;
      });
    }

    if (!topInfoItem['key'].includes('.')) {
      topInfoDisplay = alertDetail[topInfoItem['key']];

      if (topInfoItem['key'] === 'relatedPartyNames') {
        topInfoDisplay = alertDetail[topInfoItem['key']]
          ? alertDetail[topInfoItem['key']]
              .replace(/'/g, '')
              .replace('[', '')
              .replace(']', '')
          : '-';
      }
    }

    if (topInfoItem['key'] === 'alertStatus') {
      switch (alertDetail[topInfoItem['key']]) {
        case 0:
        case '0':
          topInfoDisplay = 'Open';
          break;

        case 3:
        case '3':
          topInfoDisplay = 'Under Investigation';
          break;

        case 1:
        case '1':
          topInfoDisplay = 'Closed';
          break;
        default:
          topInfoDisplay = 'Status Unavailable';
          break;
      }
    }

    let topInfoDisplayElement = topInfoDisplay !== 'nan' ? topInfoDisplay : '-';

    // Display alert closure reason only if alert is closed
    if (topInfoItem['key'] === 'nsAlertReasonDesc') {
      if (alertDetail.alertStatus === 1) {
        topInfoBar.push(
          <p>
            {topInfoItem['label']}: <b>{topInfoDisplayElement}</b>
          </p>
        );
      }
    } else {
      topInfoBar.push(
        <p>
          {topInfoItem['label']}: <b>{topInfoDisplayElement}</b>
        </p>
      );
    }
  }

  let hitScoreColor = null;
  switch (alertDetail['alertLevel']) {
    case 'L1':
      hitScoreColor = '#4CAF50';
      break;
    case 'L2':
      hitScoreColor = '#ff934f';
      break;
    case 'L3':
      hitScoreColor = '#E85252';
      break;
    default:
      hitScoreColor = '#4CAF50';
      break;
  }

  return (
    <div className={style.topInfo}>
      <div
        className={classnames('col-md-2')}
        style={{ justifyContent: 'center', display: 'flex' }}>
        <SemiCircularBar
          thickness={10}
          color={hitScoreColor}
          min={0}
          max={100}
          value={Number(alertDetail['alertScore']).toFixed(2)}
          showMin
          showMax
          showText={true}
          text={alertDetail['alertLevel']}
        />
      </div>
      <div className="col-sm-10">
        <div className={style.inforBarItems}>{topInfoBar}</div>
      </div>
      {/*<div className={classnames("col-md-1")}>
        <label>Reason:</label>
        <p>{alertDetail['reason']}</p>
      </div>*/}
      {/* <div className={classnames("col-md-2")} style={{borderLeft: 'solid 0.2px #ddeeef'}}>
        <div className={style.statsTable}>
          <div><label>Handled:</label><span>{hitStatusStats['handled']}</span></div>
          <div><label>Unhandled:</label><span>{hitStatusStats['unhandled']}</span></div>
        </div>
      </div>
      <div className={classnames("col-md-1")}>
        <button className={style.actionBtn} onClick={() => toggleBatchActionModal([])}>Actions</button>
      </div> */}
    </div>
  );
};

export default TopInfoBar;
